// @core/api/endpoints/booking/register_booking_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingTypeDefinitionResponse,
  RegisterBookingTypeRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Register booking type
 * Registers a new booking type. Products call this on startup to declare their bookable entity types (trainer.session, carsharing.trip, property.short_term, etc.). BookingService then manages lifecycle for any entity with BookingAspect of this type.
 */
export async function RegisterBookingType(
  data: RegisterBookingTypeRequest,
  options?: RequestOptions
): Promise<BookingTypeDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-types`;
  const requestOptions = options;
  return client.post<BookingTypeDefinitionResponse>(requestPath, data, requestOptions);
}
